













import { Vue, Component, Prop } from "vue-property-decorator";

// Enums/Data
import { DaysOfWeekTypes } from "@/data/enums";

// Types
import { IClient } from "@/models/clients";

@Component
export default class BaseRuleDayOfWeekField extends Vue {
  // Props

  @Prop({ required: true })
  public value!: IClient["invoice_consolidation_base_rule_day_of_week"];

  @Prop({ required: true })
  public brandValue!: IClient["invoice_consolidation_base_rule_day_of_week"];

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Getters

  public get dayOfTheWeekValue() {
    return this.value;
  }

  // Setters

  public set dayOfTheWeekValue(value) {
    this.$emit("input", value);
  }

  // Computed

  public get daysOfWeekOptions() {
    return [
      {
        value: DaysOfWeekTypes.MONDAY,
        leftLabel: this.$t("_.monday")
      },
      {
        value: DaysOfWeekTypes.TUESDAY,
        leftLabel: this.$t("_.tuesday")
      },
      {
        value: DaysOfWeekTypes.WEDNESDAY,
        leftLabel: this.$t("_.wednesday")
      },
      {
        value: DaysOfWeekTypes.THURSDAY,
        leftLabel: this.$t("_.thursday")
      },
      {
        value: DaysOfWeekTypes.FRIDAY,
        leftLabel: this.$t("_.friday")
      },
      {
        value: DaysOfWeekTypes.SATURDAY,
        leftLabel: this.$t("_.saturday")
      },
      {
        value: DaysOfWeekTypes.SUNDAY,
        leftLabel: this.$t("_.sunday")
      }
    ];
  }
}
